
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalClosedLeft as ObiThreewayDigitalClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-closed-left.js';
 
 
 

 
 export const ObiThreewayDigitalClosedLeft = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-closed-left',
   elementClass: ObiThreewayDigitalClosedLeftElement,
   events: {
     
   }
  });
 
 